import { useState } from 'react';
import ShareMediaKitModal from './ShareMediaKitModal';

interface MediaKitShareButtonProps {
    athleteUserId: number;
}

export default function MediaKitShareButton({ athleteUserId }: MediaKitShareButtonProps) {
    const [showShare, setShowShare] = useState(false);

    return (
        <>
            <button
                type="button"
                className="media-kit-share-btn"
                onClick={() => setShowShare(true)}
                data-testid="share-media-kit-button"
            >
                <svg className="media-kit-share-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path
                        fill="currentColor"
                        d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11A2.99 2.99 0 0 0 18 8.02c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81A2.99 2.99 0 0 0 5 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.3 0 2.4-.84 2.82-2H8.1c.42 1.16 1.52 2 2.82 2 1.66 0 3-1.34 3-3s-1.34-3-3-3z"
                    />
                </svg>
                Share
            </button>
            <ShareMediaKitModal
                open={showShare}
                onClose={() => setShowShare(false)}
                athleteUserId={athleteUserId}
            />
        </>
    );
}
